import styled from 'styled-components';
import Button from '@anm/components/buttons/Button/Button';
import { media } from '@anm/styles/helpers';

const switchPeriodWrapperMobile = media.phone`
  margin-left: 0;
  flex-direction: row-reverse;
  align-items: baseline;
  ${Button} {
    margin-right: 10px;
  }
`;

export const SwitchPeriodWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-left: auto;
  ${Button} {
    color: #2294df;
    font-size: 15px;
    text-decoration: underline;
  }
  ${switchPeriodWrapperMobile};
`;
